retail:
  title: Charter Broker System & API
  usage:
    limited: <strong>{{ value }}</strong> of <strong>{{ limit }}</strong> seats used
    unlimited: <strong>{{ value }}</strong> seats used
    description_one: "{{ count }} Broker User ({{ limit }} available)"
    description_other: "{{ count }} Broker Users ({{ limit }} available)"
  seatsAvailable_one: "{{ count }} Broker User"
  seatsAvailable_other: "{{ count }} Broker Users"
  seatsAvailableUnlimited: "Unlimited Broker Users"
  apiAccess: API Access
  manageUsers: Manage Users
  notSubscribed: You are not subscribed to the Broker system.
  subscribe: Subscribe to Broker System
  subscribeDescription: Subscribe to gain access to the broker system, iFrame, and API services.
  nextBilling: "Next billing: <strong>{{ date }}</strong>"
  renewal: "Renews: <strong>{{ date }}</strong>"
  availableSeat: Available Seat
  manageSeats: Manage Seats
  manageSeatsDescription: Manage which of your users will have access to the Charter Broker System.
  manage: Manage Subscription
  user:
    subscribed: Subscribed
    unsubscribed: Unsubscribed
    add: Add {{ name }} to your subscription
    remove: Remove {{ name }} from your subscription
    added: Added {{ name }} to your subscription
    removed: Removed {{ name }} from your subscription

  management:
    createSubscription:
      title: Subscribe to Broker System
      billingCycleLabel: 'Choose a billing cycle:'
      tierLabel: 'Choose a subscription tier:'
      acceptContractTerms: I accept the 12 month term associated to this subscription
      successNotification: You are now subscribed to the broker system
      submitLabel: Pay {{ price }} and subscribe
    updateSubscription:
      title: Manage Subscription
      upgradeLabel: Upgrade to {{ planName }}
      currentPlan: This is your current plan.
      downgradeLabel: Downgrade to {{ planName }}
      switchToAnnualLabel: Switch to annual billing
      changePaymentMethod: Change payment method
      cancelLabel: Cancel on {{ endDate }}
      cannotCancelMessage: You can only cancel your subscription in your contract's last billing cycle.
      cannotDowngradeMessage: You can only downgrade your subscription in your contract's last billing cycle.
    upgradeSubscription:
      title: Upgrade Subscription
      explanation: Your subscription will be upgraded immediately.
      actionLabel: Pay {{ amountDue }} and upgrade 
      successNotification: You subscription has been upgraded to {{ planName }}
    downgradeSubscription:
      title: Downgrade Subscription
      explanation: Your subscription will be downgraded to a {{ planName }} on {{ endDate }}.
      actionLabel: Downgrade Subscription
      successNotification: Your plan will be downgraded
    cancelDowngrade:
      title: Cancel Downgrade
      explanation: You will remain on the {{ planName }}, and billing will continue as usual on {{ billingDate }}.
      successNotification: Your downgrade has been cancelled.
    cancelSubscription:
      title: Cancel Subscription
      explanation: Your {{ planName }} will expire on <strong>{{ endDate }}</strong>, and will not renew.
      confirmation: Cancel my subscription
      actionLabel: Cancel Subscription
      successNotification: Your {{ planName }} has been cancelled
    reenableSubscription:
      title: Reenable Subscription
      successNotification: Your subscription has been reenabled
    switchAnnual:
      title: Switch to Annual Billing
      explanation: |
        You will start paying annually on your next billing date of {{ date }},
        when you will pay {{ amountDue}} for a year's subscription.
      actionLabel: Pay {{ amountDue }} and switch to annual billing
      successNotification: You have switched to annual billing
    changePaymentMethod:
      title: Change Payment Method
      description: Choose which payment method will be used for your {{ planName }}.
      primaryCard: Use your primary card
      specificCard: 'Or use a specific card:'
      successNotification: Your payment method was updated.
    undoPreviousActionExplanation: You will remain on the {{ planName }}, and billing will continue as usual on {{ billingDate }}.
  estimate:
    charges: Charges
    credit: Credits
    amountDue: Amount Due
  none: No Active Subscription

rys:
  update:
    title: API & iFrame Settings
    iFrame:
      title: iFrame Settings
      url: URL
      featuredUrl: Featured URL
    api:
      title: API Settings
      username: Username
      password: Password
      restUrl: REST URL
      graphQlUrl: GraphQL URL
      copiedPassword: Copied API Password
  enquiry:
    title: Inquiry Settings
    add: Add Recipient
    description: 'When you receive a Yacht Enquiry, we will send an email to the following recipients:'

yachtListing:
  title: Yacht Listings
  count_one: "{{ count }} Paid Yacht Listing"
  count_other: "{{ count }} Paid Yacht Listings"
  manage: Manage Yacht Listings
  subscribe: Purchase Yacht Listings
  subscribeDescription: Purchase Yacht Listings to gain access to the Fleet Management Console and Reservation System.
  none: No Paid Yacht Listings

nextBilling: "Next billing: <strong>{{ date }}</strong>"
renews: "Renews: <strong>{{ date }}</strong>"
expiresOn: Expires on {{ date, datetime }}
unlimited: unlimited

billingCycle: 
  label: Billing Cycle
  annual: Annual Billing
  monthly: Monthly Billing

price:
  perMonth: "/ month"
  perYear: "/ year"

  monthly: Monthly {{ price }}
  annual: Annual {{ price}}

unableToProcessPayment: We were unable to process your payment
